import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'BASE_UPDATE',
    smsDelete : 'BASE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        base_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        baseLoading: false,
        baseError: false,
  

        ...store
    },

    mutations : {
        ...mutations,
       
    

        SET_BASE_DETAIL(state, detail) {
            state.base_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },


        BASE_LOADING (state, loading) {
            state.baseLoading = loading;
        },

        BASE_ERROR (state, hasError) {
            state.baseError = hasError;
        },
        
       
       
    },

    actions: {
        //Base Detail
        async addBaseDetail ({commit, dispatch}, payload) {
            commit('BASE_LOADING', true);
            commit('BASE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_base_detail + payload.type, payload.base_detail,  config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
               
                return response

            }catch (e) {
                commit('BASE_ERROR', true);
            }finally {
                commit('BASE_LOADING', false);
            }
        },

        async fetchBaseDetail ({ commit },payload) {
            commit('BASE_LOADING', true);
            commit('BASE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_base_detail+payload, config);
                let response = result.data.data

                commit('SET_BASE_DETAIL', response);

            } catch(error) {
                commit('BASE_ERROR', true);
            }
            finally {
                commit('BASE_LOADING', false);
            }
        },

        
        // async deleteCampaign({commit, dispatch}, payload) {
        //     let config = {
        //         headers: {
        //           Authorization: "Bearer " + localStorage.getItem("access_token"),
        //         }
        //     };

        //     let response = await axios.delete(V1API.campaign_delete + payload.delete, config).then(result=>{
        //         let data = result.data
        //         return data
        //     })
            
        //     dispatch ('fetchCampaign')
            
        //     return response
        // },


        






       








    },

    getters: {}
}
